import React, { useState } from "react";
import TemplateListing from "./TemplateListing";
import TemplateCreation from "./TemplateCreation";

const Template = () => {
  const [showCreation, setShowCreation] = useState(false);
  const [selectedSampleTemplate, setSelectedSampleTemplate] = useState(null);

  const handleCreateNew = () => {
    setSelectedSampleTemplate(null);
    setShowCreation(true);
  };

  const handleSelectSample = (template) => {
    setSelectedSampleTemplate(template);
    setShowCreation(true);
  };

  const handleBack = () => {
    setShowCreation(false);
    setSelectedSampleTemplate(null);
  };

  return (
    <div className="p-3">
      {!showCreation ? (
        <TemplateListing
          onCreateNew={handleCreateNew}
          onSelectSample={handleSelectSample}
        />
      ) : (
        <TemplateCreation
          onBack={handleBack}
          initialTemplate={selectedSampleTemplate}
        />
      )}
    </div>
  );
};

export default Template;
